import * as React from 'react';
export const SvgFiletypeXls = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M11 3V0H2v16h12V3z', fill: '#39b468' }),
        React.createElement("path", { d: 'M11.694 5h-2.14L8.025 7.2 6.497 5h-2.14l2.547 3.8L4 13h4.178v-1.45H7.21l.815-1.15L9.81 13H12L9.096 8.8z', fill: '#fff' }),
        React.createElement("path", { d: 'M11 0l3 3h-3z', fill: '#287e49' })));
};
export default SvgFiletypeXls;
